import { Injectable } from '@angular/core';
import { HttpClientService } from '../../../../core/services/http/http-client.service';
import SafeUrlAssembler from 'safe-url-assembler';
import { Observable } from 'rxjs';
import { IEInvoiceSubscription } from '../models/e-invoice-subscription.interface';
import { IContact } from '../../../models/contact.interface';
import { ApiEndpointService } from '../../../../core/services/api-endpoint.service';
import { map } from 'rxjs/operators';

@Injectable()
export class EInvoiceSignUpService {
  constructor(private httpClientService: HttpClientService, private apiEndpointService: ApiEndpointService) {
  }

  public getContactCorporate(): Observable<IContact> {
    const endpoint = SafeUrlAssembler()
      .template(this.apiEndpointService.getEndpoint('getContactCorporate'))
      .toString();
    return this.httpClientService.get<IContact[]>(endpoint)
      .pipe(map(
        (res) => {
          const contacts = res;
          return contacts && contacts.length ? contacts[0] : null;
        }));
  }

  public updateEInvoiceSubscription(subscription: IEInvoiceSubscription): Observable<any> {
    const endpoint = SafeUrlAssembler()
      .template(this.apiEndpointService.getEndpoint('updateEInvoiceSubscription'))
      .toString();

    return this.httpClientService.post<any>(endpoint, subscription);
  }
}
